(function () {
  var LAUNCHER_WIDTH = 96;
  var LAUNCHER_HEIGHT = 38;
  var LEFT_EDGE = '-34.5px';
  var ticking = false;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getBottomPosition() {
    return isMobile() ? '170px' : '220px';
  }

  function getSmileLaunchers() {
    var launchers = new Set();

    document.querySelectorAll(
      '#smile-ui-lite-launcher-frame-container, ' +
      '#smile-ui-launcher-frame-container, ' +
      'div[id*="smile"][id*="launcher"][id*="frame"][id*="container"]'
    ).forEach(function (el) {
      launchers.add(el);
    });

    document.querySelectorAll('iframe[id*="smile"], iframe[title^="Button to open"]').forEach(function (iframe) {
      if (iframe.parentElement) {
        launchers.add(iframe.parentElement);
      }
    });

    return Array.from(launchers).filter(function (el) {
      return el && el.isConnected;
    });
  }

  function patchLauncherIframe(launcher) {
    var iframe = launcher.querySelector('iframe');

    if (!iframe) return;

    iframe.style.setProperty('width', '100%', 'important');
    iframe.style.setProperty('height', '100%', 'important');
    iframe.style.setProperty('min-width', '100%', 'important');
    iframe.style.setProperty('min-height', '100%', 'important');
    iframe.style.setProperty('border', '0', 'important');
    iframe.style.setProperty('outline', '0', 'important');

    try {
      var doc = iframe.contentDocument || iframe.contentWindow.document;

      if (!doc) return;

      var existingStyle = doc.getElementById('abmium-smile-inner-launcher-style');

      if (!existingStyle) {
        var style = doc.createElement('style');
        style.id = 'abmium-smile-inner-launcher-style';
        style.textContent = `
          html,
          body,
          .launcher-body {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
            height: 100% !important;
            overflow: hidden !important;
            box-sizing: border-box !important;
          }

          *,
          *::before,
          *::after {
            box-sizing: border-box !important;
          }

          .frame-root,
          .frame-content {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
            height: 100% !important;
            overflow: hidden !important;
          }

          button.launcher-button,
          .launcher-button {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
            height: 100% !important;
            min-width: 100% !important;
            min-height: 100% !important;
            border: 0 !important;
            outline: 0 !important;
            background: transparent !important;
          }

          .launcher-container {
            margin: 0 !important;
            padding: 0 !important;
            width: 100% !important;
            height: 100% !important;
            min-width: 100% !important;
            min-height: 100% !important;
            border-radius: 5px !important;
          }

          .launcher-content-container {
            width: 100% !important;
            height: 100% !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 3px !important;
            padding: 0 9px !important;
          }

          .launcher-icon {
            width: 17px !important;
            height: 17px !important;
            flex: 0 0 17px !important;
          }

          .launcher-text {
            font-size: 15px !important;
            line-height: 1 !important;
            font-weight: 500 !important;
          }

          .launcher-close-icon,
          .close-btn {
            width: 20px !important;
            height: 20px !important;
          }
        `;

        doc.head.appendChild(style);
      }

      if (doc.body) {
        doc.body.style.setProperty('margin', '0', 'important');
        doc.body.style.setProperty('padding', '0', 'important');
        doc.body.style.setProperty('overflow', 'hidden', 'important');
      }
    } catch (e) {}
  }

  function launcherIsOpen(launcher) {
    var iframe = launcher.querySelector('iframe');

    if (!iframe) return false;

    try {
      var doc = iframe.contentDocument || iframe.contentWindow.document;

      if (!doc) return false;

      var launcherContainer = doc.querySelector('.launcher-container');

      if (!launcherContainer) return false;

      return !launcherContainer.classList.contains('launcher-closed');
    } catch (e) {
      return false;
    }
  }

  function rewardsPanelIsOpen() {
    var selectors = [
      '#smile-ui-container',
      '#smile-ui-customer-ui-frame-container',
      '#smile-ui-lite-customer-ui-frame-container',
      'div[id*="smile"][id*="customer"]',
      'div[id*="smile"][id*="modal"]',
      'div[id*="smile"][id*="popup"]',
      'iframe[id*="customer"]',
      'iframe[title*="Rewards"]:not([title^="Button"])',
      'iframe[title*="loyalty"]:not([title^="Button"])'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);

      for (var j = 0; j < nodes.length; j++) {
        var rect = nodes[j].getBoundingClientRect();
        var styles = window.getComputedStyle(nodes[j]);

        if (
          rect.width > 180 &&
          rect.height > 180 &&
          styles.display !== 'none' &&
          styles.visibility !== 'hidden' &&
          Number(styles.opacity) !== 0
        ) {
          return true;
        }
      }
    }

    return false;
  }

  function lockLauncher(launcher, hideLauncher) {
    launcher.style.setProperty('position', 'fixed', 'important');
    launcher.style.setProperty('left', LEFT_EDGE, 'important');
    launcher.style.setProperty('bottom', getBottomPosition(), 'important');
    launcher.style.setProperty('width', LAUNCHER_WIDTH + 'px', 'important');
    launcher.style.setProperty('height', LAUNCHER_HEIGHT + 'px', 'important');
    launcher.style.setProperty('transform', 'rotate(-90deg)', 'important');
    launcher.style.setProperty('transform-origin', 'center center', 'important');
    launcher.style.setProperty('z-index', '2147483000', 'important');
    launcher.style.setProperty('overflow', 'hidden', 'important');
    launcher.style.setProperty('border-radius', '5px', 'important');

    if (hideLauncher) {
      launcher.style.setProperty('opacity', '0', 'important');
      launcher.style.setProperty('visibility', 'hidden', 'important');
      launcher.style.setProperty('pointer-events', 'none', 'important');
    } else {
      launcher.style.setProperty('opacity', '1', 'important');
      launcher.style.setProperty('visibility', 'visible', 'important');
      launcher.style.setProperty('pointer-events', 'auto', 'important');
    }

    patchLauncherIframe(launcher);
  }

  function fixSmileLauncher() {
    if (ticking) return;

    ticking = true;

    window.requestAnimationFrame(function () {
      var launchers = getSmileLaunchers();

      var hideLauncher = rewardsPanelIsOpen() || launchers.some(function (launcher) {
        return launcherIsOpen(launcher);
      });

      launchers.forEach(function (launcher) {
        lockLauncher(launcher, hideLauncher);
      });

      ticking = false;
    });
  }

  function runFixSequence() {
    fixSmileLauncher();

    setTimeout(fixSmileLauncher, 100);
    setTimeout(fixSmileLauncher, 300);
    setTimeout(fixSmileLauncher, 800);
    setTimeout(fixSmileLauncher, 1500);
    setTimeout(fixSmileLauncher, 3000);
  }

  document.addEventListener('DOMContentLoaded', runFixSequence);
  window.addEventListener('load', runFixSequence);
  window.addEventListener('resize', runFixSequence);
  window.addEventListener('focus', runFixSequence);

  document.addEventListener('click', runFixSequence, true);
  document.addEventListener('keyup', runFixSequence, true);

  new MutationObserver(function () {
    fixSmileLauncher();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
